const geracao_relatorio_inconsistencias_planejamento_reordenamento = {
  path: "/geracao-relatorio-inconsistencias-planejamento-reordenamento",
  redirect: "/geracao-relatorio-inconsistencias-planejamento-reordenamento",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Gerar Relatório Inconsistências Planejamento/Reordenamento",
  },
  children: [
    {
      path: "/geracao-relatorio-inconsistencias-planejamento-reordenamento",
      name: "geracao-relatorio-inconsistencias-planejamento-reordenamento",
      component: () =>
        import(
          "@/views/GerarRelatorioInconsistenciasPlanejamentoReordenamento/GerarRelatorioInconsistenciasPlanejamentoReordenamento.vue"
        ),
    },
  ],
};

export { geracao_relatorio_inconsistencias_planejamento_reordenamento };
